export default function ComingSoonPage({ title }) {
    return <div className="my-5 py-5 card text-center">
        <div className="h1 my-5">{`${title} Page coming soon...`}</div>
    </div>
}